var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 31,
    viewBox: "0 0 20 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2834 11.937C19.2278 11.8372 19.1473 11.7541 19.0499 11.6963C18.9525 11.6385 18.8419 11.6081 18.7292 11.6081H10.3841L11.7832 0.720634C11.7982 0.574922 11.7647 0.428305 11.6879 0.304389C11.6112 0.180472 11.4957 0.0864673 11.3601 0.0375095C11.2245 -0.0114483 11.0767 -0.01251 10.9405 0.0344953C10.8042 0.0815005 10.6875 0.173838 10.609 0.296639L0.460572 18.4051C0.401227 18.5034 0.368701 18.6161 0.366348 18.7315C0.363995 18.8468 0.3919 18.9608 0.447187 19.0615C0.502473 19.1622 0.583139 19.2461 0.680868 19.3045C0.778596 19.3629 0.88985 19.3937 1.00316 19.3937H9.22349L8.11475 30.2976C8.10385 30.4428 8.14095 30.5875 8.22014 30.7088C8.29933 30.83 8.41607 30.9208 8.55177 30.9667C8.68747 31.0126 8.83434 31.011 8.96902 30.9621C9.1037 30.9131 9.21844 30.8197 9.29499 30.6967L19.2757 12.5902C19.3336 12.4917 19.3648 12.3794 19.3662 12.2647C19.3675 12.1499 19.3389 12.0369 19.2834 11.937Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.2e1700b41ce769ab9c1a2101a2554ef1.svg";
export { ForwardRef as ReactComponent };